import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Phase 13d — Preserve the full intended URL (path + query + hash) across
// the login round-trip so `/expenses/new?prefill=<id>` survives.
function buildLoginRedirect(location) {
  const target = `${location.pathname}${location.search || ""}${location.hash || ""}`;
  return `/login?redirect=${encodeURIComponent(target)}`;
}

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="loading-screen">
        Loading…
      </div>
    );
  }
  if (!user) {
    // Skip the redirect param for the root path — nothing useful to preserve.
    const to = location.pathname === "/" && !location.search && !location.hash
      ? "/login"
      : buildLoginRedirect(location);
    return <Navigate to={to} replace />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
